// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.domo-input {
  background-color: transparent;
  border: 1px solid #4D4D4D;
  color: white;
  border-radius: 8px;
  padding: 0.75rem 1rem;
}

.domo-input:focus {
  background-color: transparent;
  border-color: #f09502;
  box-shadow: none;
  color: white;
}

.domo-input:disabled {
  background-color: #2a2a2a;
  border-color: #3d3d3d;
  color: #8c8c8c;
  cursor: not-allowed;
  opacity: 0.8;
}

.domo-input::placeholder {
  color: #8C8C8C;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

select.domo-input option {
  background-color: #1a1a1a;
  color: white;
}

input[type="datetime-local"].domo-input::-webkit-calendar-picker-indicator {
  filter: invert(1);
}
`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/project-wizard/steps/wizard-step-basic/wizard-step-basic.component.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".domo-input {\n  background-color: transparent;\n  border: 1px solid #4D4D4D;\n  color: white;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n}\n\n.domo-input:focus {\n  background-color: transparent;\n  border-color: #f09502;\n  box-shadow: none;\n  color: white;\n}\n\n.domo-input:disabled {\n  background-color: #2a2a2a;\n  border-color: #3d3d3d;\n  color: #8c8c8c;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.domo-input::placeholder {\n  color: #8C8C8C;\n}\n\n.form-label {\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n}\n\nselect.domo-input option {\n  background-color: #1a1a1a;\n  color: white;\n}\n\ninput[type=\"datetime-local\"].domo-input::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
